import { initContract } from '@ts-rest/core';
import { activityContract } from './activity.contract';
import { accountContract } from './account.contract';
import { adminReportAuditContract } from './admin-report-audit.contract';
import { attributionContract } from './attribution.contract';
import { authContract } from './auth.contract';
import { classifyContract } from './classify.contract';
import { consentContract } from './consent.contract';
import { feedbackContract } from './feedback.contract';
import { feedbackOfferContract } from './feedback-offer.contract';
import { labelsContract } from './labels.contract';
import { manageContract } from './manage.contract';
import { mcpContract } from './mcp.contract';
import { preferencesContract } from './preferences.contract';
import { pushContract } from './push.contract';
import { scanContract } from './scan.contract';
import { stripeContract } from './stripe.contract';
import { subscriptionContract } from './subscription.contract';
import { suggestionsContract } from './suggestions.contract';

const c = initContract();

export const appContract = c.router({
  account: accountContract,
  adminReportAudit: adminReportAuditContract,
  attribution: attributionContract,
  auth: authContract,
  manage: manageContract,
  mcp: mcpContract,
  preferences: preferencesContract,
  push: pushContract,
  suggestions: suggestionsContract,
  labels: labelsContract,
  activity: activityContract,
  classify: classifyContract,
  consent: consentContract,
  feedback: feedbackContract,
  feedbackOffer: feedbackOfferContract,
  scan: scanContract,
  stripe: stripeContract,
  subscription: subscriptionContract,
});
